import { useEffect, useState } from "react";
import { Singleton } from "../../../../../core/services/Singleton";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { SelectRol } from "../../../../admin/select/SelectRol";
import usePaginator from "../../../../theme/Component/usePaginator";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { _AgencyRole } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { AgencyUser } from "../AgencyUser/AgencyUser";


interface Props {
    idAgency: number;
}

export const AgencyRole = ({ idAgency }: Props) => {

    const role = useDataBean(_AgencyRole);
    const paginador = usePaginator();
    const single = Singleton.getInstance();
    const [Role, setRole] = useState<number>(null)
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalinrole, setModalinrole] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page, idAgency])

    const getLista = () => {

        role.instance.getAgencyRoleCatalog(idAgency, Role, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        role.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        role.instance.deleteAgencyRole(role.bean.IDAgencyRole).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        role.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const addAgencyRole = () => {

        role.instance.addAgencyRole(idAgency, role.bean.IDRole, single.getAccountID()).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const head = [
        { title: 'ID', property: 'IDAgencyRole', visible: true },
        { title: 'Role', property: 'RoleName', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Usuarios en Role', icono: 'ri-shield-user-line', visible: single.canEdit(), evento: () => { setModalinrole({ ...modalinrole, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <label>Roles de la Agencia</label>
            </div>
            <div className="col-md-4">
                <SelectRol idSelector={Role} onChange={(e: any) => { setRole(e) }}></SelectRol>
            </div>
            <div className="col-md-6 mt-4 p-2">
                <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={role.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={addAgencyRole}>
                    <div className="row">
                        <div className="col-md-12">
                            <SelectRol idSelector={role.bean.IDRole} onChange={(e: any) => { role.setBean({ ...role.bean, "IDRole": e }) }}></SelectRol>
                        </div>
                    </div>
                </Modal>
                <Modal modal={modalinrole} updateModal={setModalinrole}>
                    <div className="row">
                        <AgencyUser idAgencyRole={role.bean.IDAgencyRole} />
                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}